import type { UpdateUserAPIRequest } from "@/common/types/user";
import { useState } from "react";
import { updateUser as updateUserService } from "@/services/auth";
import { t } from "i18next";

interface UseUpdateUserState {
  updateUser: (body: UpdateUserAPIRequest) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
}

export const useUpdateUser = (): UseUpdateUserState => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const updateUser = async (body: UpdateUserAPIRequest): Promise<void> => {
    setLoading(true);
    setError(false);
    try {
      const response = await updateUserService(body);
      if (response.message == "Updated") {
        setResult(true);
      } else {
        throw new Error(t("common.error"));
      }
    } catch {
      setError(true);
      setResult(false);
    } finally {
      setLoading(false);
    }
  };
  return { updateUser, result, loading, error };
};
